import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  SubTitle,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Line } from "react-chartjs-2";
import themeColours from "../../functions/get-theme-colours";
import { createVerticalGradient } from "../../functions/color-helpers";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Title,
  SubTitle,
  Tooltip,
  Legend,
  ChartDataLabels
);

export default function LineChart({
  datasets = [],
  title = "",
  subtitle = "",
}) {
  const BASE_COLOUR_COUNT = 10;
  const dataMax = React.useMemo(() => {
    return Math.max(
      ...datasets.map((dataset) =>
        dataset.data
          .map((item) => item.y)
          .reduce((prev, current) => Math.max(prev, current))
      )
    );
  }, [datasets]);

  if (!datasets || !datasets.length) {
    return;
  }

  const chartData = {
    labels: datasets[0].data.map((item) => item.x), // x-axis labels
    datasets: datasets.map((dataset, dIndex) => ({
      type: "line",
      data: dataset.data.map((item) => item.y), // y-axis values
      label: dataset.label, // legend label
      borderColor:
        themeColours[(dIndex + BASE_COLOUR_COUNT) % themeColours.length],
      backgroundColor: (context) => {
        const { chart } = context;
        const { ctx, chartArea } = chart;

        if (!chartArea) return null;

        return createVerticalGradient(
          ctx,
          chartArea,
          themeColours[dIndex % themeColours.length],
          0.4
        );
      },
      fill: "origin",
      datalabels: {
        display: false,
      },
    })),
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    scales: {
      x: {
        display: true,
        ticks: {
          color: "#a0a0a0", // $clr-base-ltr
          autoskip: true,
        },
      },
      y: {
        display: true,
        color: "#a0a0a0",
        min: 0,
        suggestedMax: dataMax,
        ticks: {
          color: "#a0a0a0", // $clr-base-ltr
          autoskip: true,
        },
        grid: {
          color: "#a0a0a0", // $clr-base-ltr
        },
      },
    },
    plugins: {
      title: {
        display: true,
        position: "top",
        text: title,
        color: "white",
        font: {
          size: 24,
          family: "proxima-nova",
        },
      },
      subtitle: {
        display: true,
        text: subtitle,
      },
      legend: {
        position: "top",
        align: "end",
        labels: {
          color: "white",
        },
      },
    },
  };

  return <Line data={chartData} options={chartOptions}></Line>;
}
